import { css } from '@emotion/react';
import React, { useState } from 'react';
import { breakpoints, colors, spacing } from '../../../utils/styleguide';
import IconButton from '../buttons/IconButton';
import Typography from '../text/Typography';
import Icon from '../Icon';
import BannerWrapper from './BannerWrapper';
import { microcopySet, useMicrocopy } from '../../../utils/contentfulMicrocopy';
import ModernModal from '../modals/ModernModal';

const KlarnaAttentionBanner = () => {
  const [open, setOpen] = useState(false);
  const t = useMicrocopy();

  return (
    <>
      <BannerWrapper>
        <div
          css={css`
            padding-right: ${spacing[2]}px;
            flex-grow: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            position: relative;
          `}
        >
          <Icon
            css={css`
              z-index: 2;
            `}
            desktopSize={32}
            size={24}
            name={'x2'}
            stroke={colors.greenDark}
            fill={colors.greenDark}
          />
        </div>
        <div
          css={css`
            border-left: 1px ${colors.greenDark} solid;
            padding-left: ${spacing[4]}px;
            min-height: ${spacing[4]}px;
            display: flex;
            align-items: center;
            ${breakpoints.tablet} {
              min-height: ${spacing[5]}px;
          `}
        >
          <Typography variant={'detailBold'} color={colors.greenDark}>
            {t(microcopySet.KLARNA_ATTENTION_BANNER, 'bannerContent')}
          </Typography>
        </div>
        <div
          css={css`
            display: flex;
            justify-content: flex-end;
            flex-grow: 1;
          `}
        >
          <IconButton
            desktopIconSize={24}
            iconSize={18}
            iconName={'info-outline2'}
            ariaLabel={'more info'}
            onClick={() => setOpen(true)}
            variant={'onlyIcon'}
            stroke={colors.greenDark}
          />
        </div>
      </BannerWrapper>
      <ModernModal
        header={t(microcopySet.KLARNA_ATTENTION_BANNER, 'modalHeader')}
        body={t(microcopySet.KLARNA_ATTENTION_BANNER, 'modalBody')}
        open={open}
        onClose={() => setOpen(false)}
        close={t(microcopySet.KLARNA_ATTENTION_BANNER, 'modalCloseButton')}
      />
    </>
  );
};

export default KlarnaAttentionBanner;
